"use client";

import React from "react";
import { ArrowRight, BarChart3, CloudCog, Settings2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const solutions = [{
  title: "Project Management",
  description: "Senior-level delivery of complex programmes using outcome-based models to ensure precision and absolute transparency throughout the lifecycle.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/strategic_project_delivery.png",
  link: "/ServicesPage",
  icon: BarChart3
}, {
  title: "ServiceNow Migration",
  description: "End-to-end implementation and migration strategies that modernize your digital workflows and drive peak operational performance.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/servicenow_workflow_automation.png",
  link: "/ServicesPage",
  icon: CloudCog
}, {
  title: "Field Services",
  description: "Boutique technical support including network surveys and structured cabling, delivered by senior experts with a results-obsessed mindset.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/technical_infrastructure_support.png",
  link: "/ServicesPage",
  icon: Settings2
}];
export default function CoreSolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}